import { render } from "./GiveFeedback.vue?vue&type=template&id=73b59edc&scoped=true"
import script from "./GiveFeedback.vue?vue&type=script&lang=js"
export * from "./GiveFeedback.vue?vue&type=script&lang=js"

import "./GiveFeedback.vue?vue&type=style&index=0&id=73b59edc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b59edc"],['__file',"GiveFeedback.vue"]])

export default __exports__